import * as yup from 'yup';

const warehouseOwnershipViewSelectionSchema = yup.object().shape({
  id: yup.string().required(),
  name: yup.string().required(),
});

const schema = yup.object().shape({
  email: yup.string().email().label('Email').required(),
  firstName: yup.string().label('First Name').min(2, 'First Name should be at least 2 symbols').required(),
  lastName: yup.string().label('Last Name').min(2, 'Last Name should be at least 2 symbols').required(),
  password: yup.string().label('Password').min(2, 'Password should be at least 2 symbols'),
  confirmPassword: yup.string().oneOf([yup.ref('password'), yup.ref('password')], 'Passwords must match'),
  isDisabled: yup.bool().label('Disabled').required(),
  warehouseOwnershipViewSelection: yup.array().of(warehouseOwnershipViewSelectionSchema),
});

export default schema;
